// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orangeMain {
  width: 100%;
  margin-top: 15vh;
  font-family: Helvetica;
}
@media (max-width: 768px) {
  .orangeMain {
    margin-top: 8.4vh;
  }
}

.orangeDetail {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 16vh 0;
}
@media (max-width: 768px) {
  .orangeDetail {
    padding: 1vh;
  }
}

.orangeBarRow {
  display: flex;
  justify-content: center;
  color: #fff !important;
}

.orangeDetail h1 {
  font-weight: 700;
  font-size: 3.6vw;
  text-align: left;
  color: #f0592a !important;
}

.orangeDetail p {
  font-weight: 400;
  font-size: 1.7vw;
  text-align: left;
}

.orangeDetailRow {
  width: 12%;
  margin: 0 4%;
}

@media (max-width: 992px) {
  .orangeDetail h1 {
    font-weight: 500;
    font-size: 30px;
    text-align: left;
  }
  .orangeDetail p {
    font-weight: 200;
    font-size: 1.2rem;
    text-align: left;
  }
  .orangeDetailRow {
    width: 12%;
    margin: 0 4% 0 4%;
  }
}
@media (max-width: 768px) {
  .orangeDetail h1 {
    font-weight: 1000;
    font-size: 35px;
    text-align: center;
  }
  .orangeDetail p {
    font-weight: 400;
    text-align: center;
  }
  .orangeDetailRow {
    width: 100%;
    margin: 5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/OrangeBar/orangeBar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;AACF;AAAE;EAJF;IAKI,iBAAA;EAGF;AACF;;AAAA;EACE,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;AAGF;AAFE;EANF;IAOI,YAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAKF;;AAFA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AAKF;;AAFA;EACE,UAAA;EACA,YAAA;AAKF;;AAFA;EACE;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EAKF;EAFA;IACE,gBAAA;IACA,iBAAA;IACA,gBAAA;EAIF;EADA;IACE,UAAA;IACA,iBAAA;EAGF;AACF;AAAA;EACE;IACE,iBAAA;IACA,eAAA;IACA,kBAAA;EAEF;EACA;IACE,gBAAA;IACA,kBAAA;EACF;EAEA;IACE,WAAA;IACA,UAAA;EAAF;AACF","sourcesContent":[".orangeMain {\n  width: 100%;\n  margin-top: 15vh;\n  font-family: Helvetica;\n  @media (max-width: 768px) {\n    margin-top: 8.4vh;\n  }\n}\n\n.orangeDetail {\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 16vh 0;\n  @media (max-width: 768px) {\n    padding: 1vh;\n  }\n}\n\n.orangeBarRow {\n  display: flex;\n  justify-content: center;\n  color: #fff !important;\n}\n\n.orangeDetail h1 {\n  font-weight: 700;\n  font-size: 3.6vw;\n  text-align: left;\n  color: #f0592a !important;\n}\n\n.orangeDetail p {\n  font-weight: 400;\n  font-size: 1.7vw;\n  text-align: left;\n}\n\n.orangeDetailRow {\n  width: 12%;\n  margin: 0 4%;\n}\n\n@media (max-width: 992px) {\n  .orangeDetail h1 {\n    font-weight: 500;\n    font-size: 30px;\n    text-align: left;\n  }\n\n  .orangeDetail p {\n    font-weight: 200;\n    font-size: 1.2rem;\n    text-align: left;\n  }\n\n  .orangeDetailRow {\n    width: 12%;\n    margin: 0 4% 0 4%;\n  }\n}\n\n@media (max-width: 768px) {\n  .orangeDetail h1 {\n    font-weight: 1000;\n    font-size: 35px;\n    text-align: center;\n  }\n\n  .orangeDetail p {\n    font-weight: 400;\n    text-align: center;\n  }\n\n  .orangeDetailRow {\n    width: 100%;\n    margin: 5%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
